import { Card } from '@mews-commander/ui';
import { WithScope } from '@mews-commander/types';
import Dashboard from './Dashboard';
import ImportFileForm from './ImportFileForm';

const DashboardView = ({ scope }: WithScope) => (
    <>
        <Dashboard scope={scope} />
        <Card>
            <ImportFileForm form="import-form" accept="application/json" />
        </Card>
    </>
);

export default DashboardView;
